
import {SourceTag} from 'components/sources'
import {Later} from 'utils/timers'
import PulseCategory from '../pulse-category.vue'
import TopicTile from '../topic-tile.vue'

export default {
  components: {SourceTag, PulseCategory, TopicTile},
  props: {
    item: {type: Object, required: true}
  },
  data() {
    return {
      time: undefined,
      popup_visible: false,
      ago_timer: new Later(1000),
      opened_popups: new Set(),
    }
  },
  computed: {
    persona(){
      return this.item.entity_type === 'persona' && this.parent_name
    },
    topic(){
      return this.item.entity_type === 'topic'
    },
    name(){
      return this.item.entity_name || this.item.tag
    },
    parent_name(){
      return this.item.parent_entity_name
    },
    parent_type(){
      return this.item.parent_entity_type
    },
    logo_url() {
      return this.item.entity_logo_url || this.item.tag_icon
    },
    parent_logo_url() {
      return this.item.parent_entity_logo_url

    },
    category(){
      return this.item.category
    },
    seen(){
      return this.item.seen
    },
    category_label() {
      return this.item.category_label
    },
    created_at(){
      return this.item.created_at
    },
    changed_at(){
      return this.item.changed_at
    },
    changed(){
      if (!this.changed_at) {
        return false
      }
      return this.created_at !== this.changed_at
    }
  },
  mounted() {
    this.formatAgo()
    this.ago_timer.repeat(this.formatAgo)
  },
  beforeUnmount() { 
    this.ago_timer.abort()
  },
  methods: {
    
    formatAgo() {
      if (this.changed) {
        this.time = `${this.formatTimestamp(this.created_at)} • Updated ${this.formatTimestamp(this.changed_at)}`
        return
      }
      this.time = this.formatTimestamp(this.created_at)
    },
    formatTimestamp(date_input) {
      const created = new Date(date_input)
      const now = new Date() // Current system time
  
      // Difference is universal (ms since epoch), regardless of timezone
      const diffInMs = now.getTime() - created.getTime()
      const mins = Math.floor(diffInMs / 60000)
      const hours = Math.floor(mins / 60)
      const days = Math.floor(hours / 24)
      
      if (mins < 1) return 'now'
      if (mins < 60) return `${mins}m`
      if (hours < 24) return `${hours}h`
      if (days < 7) return `${days}d`

      // Use UTC specific formatting
      const options = {month: 'short', day: 'numeric', timeZone: 'UTC'}
  
      if (created.getUTCFullYear() !== now.getUTCFullYear()) {
        options.year = 'numeric'
      }

      return created.toLocaleDateString('en-US', options)
    }
  }
}
